import React from 'react';
import { View, Text, StyleSheet } from 'react-native';

const TutorialScreen = () => {
    return (
        <View style={styles.container}>
            <Text>This is where you willll add tutorial or help information.</Text>
        </View>
    );
};

const styles = StyleSheet.create({
    container: {
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center',
    },
});

export default TutorialScreen;
